import React, { useState, useEffect, useContext } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
import { Link } from "react-router-dom"

// users
import GlobalState from "../../../contexts/GlobalState"
import withRouter from "components/Common/withRouter"
import { getTranslatedRole } from "utils/general"
import UserRoleDropdown from "./UserRoleDropdown"

const ProfileMenu = props => {
  const [state] = useContext(GlobalState)
  const [menuDropdown, setMenuDropdown] = useState(false)
  const [username, setUsername] = useState("Admin")
  const [role, setRole] = useState("")
  const [nameIcon, setNameIcon] = useState()
  const [roleMenu, setRoleMenu] = useState(false)

  useEffect(() => {
    if (state.authUser != null) {
      const obj = JSON.parse(state.authUser)
      setUsername(obj.username)

      let role = obj.activeRole ? obj.activeRole : obj.role
      setRole("UserRoles." + getTranslatedRole(role))

      if (obj.firstName !== undefined && obj.lastName !== undefined) {
        let iconName = ""
        iconName = obj.firstName.charAt(0) + obj.lastName.charAt(0)
        setNameIcon(iconName.toUpperCase())
      } else {
        let iconName = ""
        iconName = obj.username.charAt(0)
        setNameIcon(iconName.toUpperCase())
      }
    }
  }, [])

  return (
    <>
      <Dropdown
        isOpen={menuDropdown}
        toggle={() => {
          setMenuDropdown(!menuDropdown)
          setRoleMenu(false)
        }}
        className="d-inline-block"
      >
        <DropdownToggle
          aria-haspopup="menu"
          aria-label={props.t("Profile")}
          tag="button"
          id="page-header-user-dropdown"
          className="btn header-item focus-topbar"
        >
          <div className="avatar-xs mx-auto d-inline-block header-profile-icon">
            <span
              className={
                "avatar-title rounded-circle bg-light-bg text-darker-primary font-size-16"
              }
            >
              {nameIcon}
            </span>
          </div>
          <div
            className="d-none d-xl-inline-block"
            style={{
              textAlign: "left",
              verticalAlign: "middle",
              minHeight: "40px",
            }}
          >
            <div className="d-grid ms-2 me-1">
              <span className="">{username}</span>
              <small className="">{props.t(role)}</small>
            </div>
          </div>

          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu-end" role="menu">
          {/* PROFILE SETTINGS */}
          <Link
            to="/profile"
            className="dropdown-item dropdown-item-highlight"
            role="menuitem"
            tabIndex="0"
          >
            <i className="bx bx-user font-size-16 align-middle me-2" />
            <span>{props.t("My profile")}</span>
          </Link>

          {/* USER ROLE */}
          <DropdownItem
            tag="button"
            toggle={false}
            className="dropdown-item dropdown-item-highlight"
            type="button"
            aria-expanded={roleMenu}
            onClick={() => setRoleMenu(!roleMenu)}
            style={{ minWidth: "170px" }}
          >
            <i className="fab fa-dev text-muted font-size-16 align-middle me-2" />
            <span>{props.t("User Role")}</span>
            <div className="float-end">
              <i
                className={`ms-1 bx ${
                  roleMenu ? "bx-chevron-up" : "bx-chevron-down"
                }`}
              />
            </div>
          </DropdownItem>
          {roleMenu && (
            <div className="roles pt-2">
              <UserRoleDropdown settingRole={setRole} />
            </div>
          )}

          <div className="dropdown-divider" />

          {/* LOGOUT */}
          <Link
            to="/logout"
            className="dropdown-item dropdown-item-highlight"
            role="menuitem"
            tabIndex="0"
          >
            <i className="bx bx-power-off font-size-16 align-middle me-2 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </>
  )
}

ProfileMenu.propTypes = {
  t: PropTypes.any,
}

export default withRouter(withTranslation()(ProfileMenu))
